import { render, staticRenderFns } from "./_.vue?vue&type=template&id=d11b8354&scoped=true"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11b8354",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Product: require('/home/topspuk/builds/WLymjMOvx/0/standbyteam/topspizza.co.uk/frontend/web/components/Product.vue').default,StoreDetail: require('/home/topspuk/builds/WLymjMOvx/0/standbyteam/topspizza.co.uk/frontend/web/components/StoreDetail.vue').default})
